import React, { createContext, useState } from "react";
export const globalContext = createContext();
function ContextProvider({ children }) {
  const [sellerHomePageButton, setSellerHomePageButton] = useState(1);
  const [sellerHistoryPageButton, setSellerHistoryPageButton] = useState(1);
  const [buyerFilterBtn, setBuyerFilterBtn] = useState(1);
  const [sellerLiveRoomConnection, setSellerLiveRoomConnection] = useState(true);
  const [connectingWithLiveRoom, setConnectingWithLiveRoom] = useState(true);
  const [popupWindow, setPopupWindow] = useState(null);

  return (
    <globalContext.Provider
      value={{
        sellerHomePageButton,
        setSellerHomePageButton,
        sellerHistoryPageButton,
        setSellerHistoryPageButton,
        buyerFilterBtn,
        setBuyerFilterBtn,
        connectingWithLiveRoom, setConnectingWithLiveRoom,
        sellerLiveRoomConnection, setSellerLiveRoomConnection,
        popupWindow, setPopupWindow
      }}
    >
      {children}
    </globalContext.Provider>
  );
}

export default ContextProvider;
